import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getCurrentYear, getInlineLoader } from "../Helpers";
import { FaInstagram, FaFacebook, FaLinkedin, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import YCSC_logo from "../assets/logo.png";

export default function Footer(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <footer className="YcscPremiumFooterWrapper">
        {/* SEHEMU KUU YA FOOTER (Inatumia --backgroundColor) */}
        <div className="container py-5">
          <div className="row g-4 justify-content-between">
            {/* BRAND BRIEF & SOCIALS */}
            <div className="col-12 col-md-4">
              <div className="d-flex align-items-center flex-shrink-0 gap-2">
                <img
                  src={YCSC_logo}
                  alt="YCSC SACCOS Logo"
                  className="align-self-center brand-logo-transition saccos-footer-logo"
                />
                <h5 className="footer-brand-title fw-bold mb-3">
                  YCSC <span className="text-secondary-accent">SACCOS</span>
                </h5>
              </div>
              <p className="footer-minimal-desc mb-4">
                Ushirika thabiti kuelekea maendeleo ya kiuchumi na kijamii.
                "Mshikamano Daima".
              </p>
              {/* MITANDAO YA KIJAMII */}
              <div className="d-flex align-items-center gap-3 footer-social-cluster">
                <a
                  href="https://www.instagram.com/ycsc_saccos?igsh=MW5zMjA2NmI1ZWp1MA=="
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon-anchor"
                >
                  <FaInstagram size={20} />
                </a>
                <a
                  href="https://www.facebook.com/ycsc_saccos"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon-anchor"
                >
                  <FaFacebook size={20} />
                </a>
                <a
                  href="https://www.youtube.com/ycsc_saccos"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon-anchor"
                >
                  <FaYoutube size={20} />
                </a>
              </div>
            </div>

            {/* NAV LINKS */}
            <div className="col-6 col-md-3 offset-md-1">
              <h6 className="footer-section-heading text-uppercase tracking-wider mb-3">
                Viungo Muhimu
              </h6>
              <ul className="list-unstyled footer-nav-list d-flex flex-column gap-2 m-0">
                <li onClick={() => appContext.navTo({ item: "" || "home" })}>
                  Nyumbani
                </li>
                <li onClick={() => appContext.navTo({ item: "about_us" })}>
                  Kuhusu Sisi
                </li>
                <li onClick={() => appContext.navTo({ item: "services" })}>
                  Huduma Zetu
                </li>
                <li onClick={() => appContext.navTo({ item: "news" })}>
                  Habari & Matukio
                </li>
                <li onClick={() => appContext.navTo({ item: "gallery" })}>
                  Matunzio
                </li>
                <li onClick={() => appContext.navTo({ item: "faqs" })}>FAQs</li>
                <li onClick={() => appContext.navTo({ item: "contact_us" })}>
                  Mawasiliano
                </li>
              </ul>
            </div>

            {/* MAWASILIANO */}
            <div className="col-6 col-md-3">
              <h6 className="footer-section-heading text-uppercase tracking-wider mb-3">
                Ofisi & Makao
              </h6>
              <p className="footer-contact-p mb-1 fw-medium">
                Dar es Salaam, Tanzania
              </p>
              <a
                href="mailto:info@ycsc.co.tz"
                className="footer-contact-p d-block mb-1 font-monospace small"
              >
                info@ycsc.co.tz
              </a>
              <a
                href="tel:+255767210164"
                className="footer-contact-p d-block m-0 small font-monospace"
              >
                +255 767 210 164
              </a>
            </div>
          </div>
        </div>

        {/* SEHEMU YA CHINI (Inatumia --primaryColor) */}
        <div className="footer-prestige-bottom-bar py-3">
          <div className="container">
            <div className="row align-items-center g-2">
              <div className="col-12 col-md-6 text-center text-md-start">
                <span className="copyright-text">
                  &copy; {getCurrentYear()} YCSC SACCOS Limited. Haki zote
                  zimehifadhiwa.
                </span>
              </div>
              {/* <div className="col-12 col-md-6 text-center text-md-end">
                <span className="developer-credits-text">
                  Website Developed By{" "}
                  <a
                    href="https://werenium.com"
                    target="_blank"
                    rel="noreferrer"
                    className="werenium-anchor fw-bold text-white"
                  >
                    Werenium
                  </a>
                </span>
              </div> */}
            </div>
          </div>
        </div>
      </footer>
    );
  } else {
    return (
      <div className="container mSupportLoading py-5 text-center">
        {getInlineLoader()}
      </div>
    );
  }
}
